import { render, staticRenderFns } from "./routing.vue?vue&type=template&id=6e0afe80&scoped=true&"
import script from "./routing.vue?vue&type=script&lang=js&"
export * from "./routing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0afe80",
  null
  
)

export default component.exports